import {
  IContractBook,
  SupportedChainId,
  contractBook,
} from "@eulerxyz/core-sdk"
import { ContractFunctionConfig } from "@eulerxyz/evc-sdk"
import { BaseTransactionFactory } from "./BaseTransactionFactory"
import {
  TosTransactionItem,
  TransactionItemUnion,
  TransactionItems,
  isTosTransactionItem,
} from "./types"

export class TosTransactionFactory extends BaseTransactionFactory {
  customData: {
    tosAddress: `0x${string}`
  }

  constructor(chainId: SupportedChainId, contractBook: IContractBook) {
    super(chainId, contractBook)
    const tosAddress = contractBook.termsOfUseSigner.address[chainId]
    if (!tosAddress) throw Error("Terms of Service Signer not found")
    this.customData = {
      tosAddress,
    }
  }

  typeGuardConvertMultiple(
    _transactions: TransactionItems, // todo: modify this to use more specific type
  ): ContractFunctionConfig[] {
    const contractCallReadyTxs: ContractFunctionConfig[] = []
    for (const tx of _transactions) {
      const call = this.typeGuardConvertSingle(tx)
      contractCallReadyTxs.push(call)
    }
    return contractCallReadyTxs
  }

  typeGuardConvertSingle(
    _transaction: TransactionItemUnion,
  ): ContractFunctionConfig {
    if (isTosTransactionItem(_transaction)) {
      return this.convertTos(_transaction)
    }

    throw this.errorUnsupportedTransactionType(_transaction)
  }

  convertTos(
    _transaction: TosTransactionItem,
  ): ContractFunctionConfig<
    typeof contractBook.termsOfUseSigner.abi,
    "signTos"
  > {
    return {
      functionName: "signTermsOfUse",
      abi: contractBook.termsOfUseSigner.abi,
      address: this.customData.tosAddress,
      args: [_transaction.message, _transaction.hash],
      onBehalfOfAccount: _transaction.from,
      value: 0n,
    }
  }
}
